import * as React from "react";
import { Socket } from "socket.io-client";

// We do it this way to control offline mode.
const getSocket = (): Socket => {
    // console.log("getSocket");
    let socket: any;

    if (!navigator.onLine) {
        // Create a Dummy Socket.io Object so We Can Capture and Control Dataflow.
        socket = {
            //@ts-expect-error
            removeListener: (event: string, func: any) => {
                console.log("Socket Remove Listener: ", event);
            },
            //@ts-expect-error
            emit: (event: string, func: any) => {
                console.log("Socket Emit: ", event);
            },
            //@ts-expect-error
            on: (event: string, payload: any) => {
                console.log("Socket On Event: ", event);
            },
            //@ts-expect-error
            disconnect: () => {
                console.log("Socket Disconnect.");
            },
            //@ts-expect-error
            once: (event: string, func: any) => {
                console.log("Socket Once.");
            },
        };
    } else {
        // if (!socket || !socket.id) {
        //     socket = io(SocketService.getEndpointUrl(), {
        //         transports: ["websocket"],
        //         upgrade: false,
        //     });
        // }
    }

    return socket;
};

export const socket = getSocket();

export const SocketContext = React.createContext<Socket | null>(null);
